import React from 'react'
import styled from 'styled-components'

import Field, {
  useFieldContext,
} from '../../../../../../../1stlog-ui/src/components/Field'
import Select from '../../../../../../../1stlog-ui/src/components/Select'

const Wrapper = styled.div`
  flex: 2 1 0;
  margin-left: 10px;
`

const TransportCategory = (props) => {
  const {} = props

  const { prefix } = useFieldContext()

  const options = [
    {
      value: null,
      label: i18n.t('label_none', 'Keine'),
    },
    {
      value: '0',
      label: '0',
    },
    {
      value: '1',
      label: '1',
    },
    {
      value: '2',
      label: '2',
    },
    {
      value: '3',
      label: '3',
    },
    {
      value: '4',
      label: '4',
    },
  ]

  return (
    <Wrapper>
      <Field
        name="transportCategory"
        label={i18n.t('label_abk_bk', 'BK')}
        tooltip={i18n.t('transport_category', 'Beförderungskategorie')}
        validateFields={[`${prefix}.explosiveMass`]}
        clearable={false}
        searchable
      >
        <Select
          options={options}
          direct
          placeholder={i18n.t('label_none', 'Keine')}
        />
      </Field>
    </Wrapper>
  )
}

export default TransportCategory
